import { useContext, useEffect, useMemo, useRef, useState } from "react"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";
import { dateConvert, getFullMonthSelected } from "../../../utils/Helper";
import { ProgressBar } from "primereact/progressbar";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { ToastContext } from "../../../context/ToastContext";
import { callautopopulate } from "../../../services/callautopop";
import { ListBox } from "primereact/listbox";

export const useTaskDetailsPopup = ({ projectId, detailsPopup, payloadData, header }) => {

    const { showInfo, showSuccess } = useContext(ToastContext);
    const overlayRef = useRef(null);
    const [configOpts, setConfigOpts] = useState([]);
    const [displayColumns, setDisplayColumns] = useState({ selected: [], ids: [], viewAll: false, apiCall: false });
    const isChange = useRef(null);
    const columnsSelected = useRef(displayColumns)
    const [loader, setLoader] = useState(false);
    const [rowData, setRowData] = useState([{ id: "all", title: "", children: [] }]);
    const [tooltip, setTooltip] = useState({ key: "", data: {} });
    const columns = [
        {
            key: "sr_no",
            label: "Sr. No.",
            style: { textAlign: "center", width: "50px" },
            headerStyle: { textAlign: "center" },
            sort: false,
            render: (row) => {
                return (
                    <div className="py-2">{row?.sr_no}</div>
                )
            }
        },
        {
            key: "issue_type_image_url",
            label: "Issue Type",
            hide: !displayColumns?.viewAll && !displayColumns?.ids?.includes("issue_type_image_url"),
            style: { textAlign: "center", width: "50px" },
            headerStyle: { textAlign: "center" },
            sort: false,
            render: (row) => {
                return (
                    <div className="py-2">
                        <img src={row?.issue_type_image_url} alt="" width={20} height={20} />
                    </div>
                )
            }
        },
        {
            key: "issue_key",
            label: "Issue Key",
            hide: !displayColumns?.viewAll && !displayColumns?.ids?.includes("issue_key"),
            style: { textAlign: "center", width: "80px" },
            headerStyle: { textAlign: "center" },
            render: (row) => {
                return (
                    <a href={row?.issue_url || ""} className="py-2 fw-semibold" target="_blank">{row?.issue_key || "-"}</a>
                )
            }
        },
        {
            key: "issue_summary",
            label: "Issue Subject",
            hide: !displayColumns?.viewAll && !displayColumns?.ids?.includes("issue_summary"),
            style: { width: "400px" },
            render: (row) => {
                return (
                    <div className="py-2 w100 text-truncate" title={row?.issue_summary}>{row?.issue_summary || "-"}</div>
                )
            }
        },
        {
            key: "component_name",
            label: "Assignee / Component",
            hide: !displayColumns?.viewAll && !displayColumns?.ids?.includes("component_name"),
            style: { width: "100px" },
            render: (row) => {
                return (
                    <div className="py-2 text-truncate" title={row?.component_name}>{row?.component_name || "-"}</div>
                )
            }
        },
        {
            key: "stage",
            label: "Stage",
            hide: !displayColumns?.viewAll && !displayColumns?.ids?.includes("stage"),
            style: { width: "70px" },
            sort: false,
            render: (row) => {
                let staging = row?.stage;
                if (staging) {
                    staging["total"] = parseFloat((staging?.backlog + staging?.in_progress + staging?.done)?.toFixed(2));
                }
                let obj = { backlog: (staging?.backlog * 100 / staging?.total) || 0, in_progress: (staging?.in_progress * 100 / staging?.total) || 0, done: (staging?.done * 100 / staging?.total) || 0 };

                return (
                    <div>
                        {staging?.total > 0 ? <div className="d-flex justify-content-center project-glance-stage" onMouseEnter={() => setTooltip((prev) => ({ ...prev, key: "stage", data: staging }))}>
                            <ProgressBar value={100} className='project-glance-progress grey' style={{ borderRadius: (obj?.in_progress > 0 || obj?.done > 0) ? "50rem 0px 0px 50rem" : "50rem", width: `${obj?.backlog}%` }} />
                            <ProgressBar value={100} className='project-glance-progress blue' style={{ borderRadius: obj?.backlog > 0 ? obj?.done > 0 ? 0 : "0px 50rem 50rem 0" : obj?.done > 0 ? "50rem 0px 0px 50rem" : "50rem", width: `${obj?.in_progress}%` }} />
                            <ProgressBar value={100} className='project-glance-progress green' style={{ borderRadius: (obj?.in_progress > 0 || obj?.backlog > 0) ? "0px 50rem 50rem 0px" : "50rem", width: `${obj?.done}%` }} />
                        </div> : "-"}
                    </div>
                )
            }
        },
        {
            key: "current_sprint",
            label: "Current Sprint",
            hide: !displayColumns?.viewAll && !displayColumns?.ids?.includes("current_sprint"),
            style: { width: "120px" },
            render: (row) => {
                return (
                    <div className="py-2 text-truncate" title={row?.current_sprint}>{row?.current_sprint || "-"}</div>
                )
            }
        },
        {
            key: "past_sprint",
            label: "Past Sprints",
            hide: !displayColumns?.viewAll && !displayColumns?.ids?.includes("past_sprint"),
            style: { textAlign: "center", width: "60px" },
            headerStyle: { textAlign: "center" },
            render: (row) => {
                return (
                    <div className="rounded-pill" style={{ backgroundColor: "#e1e6ea" }}>
                        {row?.past_sprint > 0 ? <div className="project-glance-stage" onMouseEnter={() => setTooltip((prev) => ({ ...prev, key: "past_sprint", data: row?.past_sprint_name?.split(",") }))}>
                            +{row?.past_sprint}
                        </div> : "-"}
                    </div>
                )
            }
        },
        {
            key: "status_name",
            label: "Status",
            hide: !displayColumns?.viewAll && !displayColumns?.ids?.includes("status_name"),
            style: { textAlign: "center", width: "100px" },
            headerStyle: { textAlign: "center" },
            render: (row) => {
                return (
                    <div className="py-2" title={row?.status_name}>
                        <div className="border rounded-pill text-center px-2 w100 text-truncate">{row?.status_name || "-"}</div>
                    </div>
                )
            }
        },
        {
            key: "issue_created",
            label: "Created",
            hide: !displayColumns?.viewAll && !displayColumns?.ids?.includes("issue_created"),
            style: { textAlign: "center", width: "100px" },
            headerStyle: { textAlign: "center" },
            render: (row) => {
                return (
                    <div className="py-2">{dateConvert(row?.issue_created) || "-"}</div>
                )
            }
        },
        {
            key: "updated_datetime",
            label: "Updated",
            hide: !displayColumns?.viewAll && !displayColumns?.ids?.includes("updated_datetime"),
            style: { textAlign: "center", width: "100px" },
            headerStyle: { textAlign: "center" },
            render: (row) => {
                return (
                    <div className="py-2">{dateConvert(row?.updated_datetime) || "-"}</div>
                )
            }
        },
        // {
        //     key: "due_date",
        //     label: "Due Date",
        //     hide: !displayColumns?.viewAll && !displayColumns?.ids?.includes("due_date"),
        //     style: { textAlign: "center", width: "100px" },
        //     headerStyle: { textAlign: "center" },
        //     render: (row) => {
        //         return (
        //             <div className="py-2">{row?.due_date || "-"}</div>
        //         )
        //     }
        // },
        {
            key: "resolution_date",
            label: "Resolved",
            hide: !displayColumns?.viewAll && !displayColumns?.ids?.includes("resolution_date"),
            style: { textAlign: "center", width: "100px" },
            headerStyle: { textAlign: "center" },
            render: (row) => {
                return (
                    <div className="py-2">{dateConvert(row?.resolution_date) || "-"}</div>
                )
            }
        },
        {
            key: "estimated_time",
            label: "Estimated",
            hide: !displayColumns?.viewAll && !displayColumns?.ids?.includes("estimated_time"),
            style: { width: "70px" },
            render: (row) => {
                return (
                    <div className="py-2">{row?.estimated_time || "-"}</div>
                )
            }
        },
        {
            key: "time_spent",
            label: "Time Spent",
            hide: !displayColumns?.viewAll && !displayColumns?.ids?.includes("time_spent"),
            style: { width: "60px" },
            render: (row) => {
                return (
                    <div className="py-2">{row?.time_spent || "-"}</div>
                )
            }
        },
        {
            key: "parent_issue_type_image_url",
            label: "Parent Issue Type",
            hide: !displayColumns?.viewAll && !displayColumns?.ids?.includes("parent_issue_type_image_url"),
            style: { textAlign: "center", width: "60px" },
            headerStyle: { textAlign: "center" },
            sort: false,
            render: (row) => {
                return (
                    <div className="py-2">
                        <img src={row?.parent_issue_type_image_url || ""} alt="" width={20} height={20} />
                    </div>
                )
            }
        },
        {
            key: "parent_issue_key",
            label: "Parent Key",
            hide: !displayColumns?.viewAll && !displayColumns?.ids?.includes("parent_issue_key"),
            style: { textAlign: "center", width: "100px" },
            headerStyle: { textAlign: "center" },
            render: (row) => {
                return (
                    <div className="py-2">{row?.parent_issue_key || "-"}</div>
                )
            }
        },
        {
            key: "parent_issue_summary",
            label: "Parent Subject",
            hide: !displayColumns?.viewAll && !displayColumns?.ids?.includes("parent_issue_summary"),
            style: { width: "190px" },
            render: (row) => {
                return (
                    <div className="py-2 text-truncate w100">{row?.parent_issue_summary || "-"}</div>
                )
            }
        },
    ]

    useEffect(() => {
        callautopopulate("project_columns_metadata")?.then(res => {
            let opts = res?.project_columns_metadata?.map(item => { return { ...item, column_header: _.findWhere(columns, { key: item?.column_display_name })?.label } });
            setConfigOpts(_.filter(opts, item => item?.column_header));
        })
        getColumnConfiguration();
    }, [])

    useEffect(() => {
        displayColumns?.apiCall && getTaskDetails();
    }, [displayColumns?.apiCall, displayColumns?.viewAll])

    useEffect(() => {
        columnsSelected.current = displayColumns;
    }, [displayColumns])

    const getTaskDetails = async () => {
        try {
            setLoader(true);
            const payload = {
                project_id: projectId,
                from_date: payloadData?.from_date || "",
                to_date: payloadData?.to_date || "",
                is_feature: payloadData?.is_feature || false,
                task_type_name: detailsPopup?.data?.key || "",
                issue_type_id: (detailsPopup?.data?.group_key === "issue_type" ? detailsPopup?.data?.group_id : 0) || 0,
                requested_user_code: (detailsPopup?.data?.group_key === "assignee" ? detailsPopup?.data?.group_id : 0) || 0,
                status_name: detailsPopup?.data?.status_name || "",
                sprint_id: (detailsPopup?.data?.group_key === "current_sprint" ? detailsPopup?.data?.group_id : 0) || 0,
                is_default_view: displayColumns?.viewAll || false
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTTASKFEATUREINFO"), payload);
            if (res) {
                const data = res?.body?.data;
                setRowData([{ id: "all", title: "", children: _.sortBy(data, "issue_key")?.map((item, idx) => { return { ...item, sr_no: idx + 1 } }) }]);
                setDisplayColumns((prev) => ({ ...prev, apiCall: false }));
                setLoader(false);
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader(false);
        }
    }

    const getColumnConfiguration = async () => {
        try {
            const res = await services.getInvokeRemote("GET", Urls("GETPROJECTUSERCOLUMNCONFIGURATION"));
            if (res) {
                const data = res?.body?.data?.column_configuration_details;
                let cols = _.filter(data?.map(item => { return { ...item, column_header: _.findWhere(columns, { key: item?.column_display_name })?.label } }), item => item?.column_header);
                setDisplayColumns((prev) => ({ ...prev, selected: cols, ids: _.pluck(cols, "column_display_name"), viewAll: _.isEmpty(_.filter(data, item => item?.column_id)), apiCall: true }));
            }
        } catch (error) {
            console.error("Error: ", error);
            setDisplayColumns((prev) => ({ ...prev, viewAll: true, apiCall: true }));
        }
    }

    const saveColumnConfiguration = async () => {
        try {
            const payload = {
                "column_ids": _.pluck(columnsSelected.current?.selected, "column_id")?.toString() || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTPROJECTUSERCOLUMNCONFIGURATION"), payload)
            if (res) {
                showSuccess("Success", res?.body?.message);
                if (displayColumns?.viewAll) {
                    setDisplayColumns((prev) => ({ ...prev, viewAll: false }));
                } else {
                    getTaskDetails();
                }
                setDisplayColumns((prev) => ({ ...prev, ids: _.pluck(columnsSelected.current?.selected, "column_display_name") }));
                isChange.current = false;
            }
        } catch (error) {
            console.error("Error: ", error);
        }
    }

    const handleExcelDownload = async () => {
        if (_.isEmpty(rowData?.[0]?.children)) {
            showInfo("Info", "There is no data to download");
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Task Details');

        const colHeaders = _.filter(columns, (item) => !(item?.key === "sr_no" || item?.key === "issue_type" || item?.key === "stage" || item?.key === "past_sprint" || item?.key === "parent_issue_type_image_url") && !item?.hide);
        const excelHeaders = _.pluck(colHeaders, "label");

        const headerRow = worksheet.addRow(excelHeaders);
        headerRow.font = { bold: true };
        headerRow.eachCell(cell => {
            cell.alignment = { horizontal: 'left', vertical: 'middle', wrapText: true };
            cell.font = { color: { argb: 'FFFFFFFF' } };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF12455D' }
            };
        });

        worksheet.views = [{ state: 'frozen', ySplit: 1 }];

        const dataFields = _.pluck(colHeaders, "key");
        rowData?.[0]?.children.forEach(rowdata => {
            let dataArray = [];
            dataFields?.forEach((field) => {
                if ((field === "issue_created" || field === "updated_datetime" || field === "due_date" || field === "resolution_date") && rowdata[field]) {
                    dataArray.push(dateConvert(rowdata[field]) || "-");
                } else {
                    dataArray.push(rowdata[field] || "-");
                }
            })
            worksheet.addRow(dataArray);
        });

        // set dynamic widths for columns according to its content
        worksheet.columns.forEach((col) => {
            let maxLength = 10;
            col.eachCell({ includeEmpty: true }, (cell) => {
                const cellValue = cell.value ? cell.value.toString() : "";
                maxLength = Math.max(maxLength, Math.min(cellValue.length, 50));
            });
            col.width = maxLength + 2;
            col.alignment = { horizontal: "left" };
        });

        const fromDate = payloadData ? payloadData?.from_date : getFullMonthSelected(new Date())?.from_date;
        const toDate = payloadData ? payloadData?.to_date : getFullMonthSelected(new Date())?.to_date;
        let name = (`${payloadData?.is_feature ? "Features" : "Tasks"}_${header?.split("-")?.map(item => item?.trim())?.splice(1)?.join("_")}_${dateConvert(fromDate, "date-month-year")}_to_${dateConvert(toDate, "date-month-year")}`)?.split(" ")?.join("_");
        const fileName = `${name}.xlsx`;

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        saveAs(blob, fileName);
    };

    const listBoxOptionTemplate = (option) => {
        return (
            <div className="d-flex align-items-center gap-3">
                <input type='checkbox' checked={_.pluck(displayColumns?.selected, "column_id")?.includes(option?.column_id)}
                    onChange={(e) => {
                        let dataArray = [...displayColumns?.selected];
                        if (e.target?.checked) {
                            dataArray.push(option);
                        } else {
                            dataArray = _.filter(dataArray, item => item?.column_id !== option?.column_id);
                        }
                        setDisplayColumns((prev) => ({ ...prev, selected: dataArray }));
                        isChange.current = true;
                    }}
                />
                <div>{option?.column_header}</div>
            </div>
        );
    };

    const getMenuItems = () => {
        return [
            {
                key: 'header',
                template: () => (
                    <div style={{ maxHeight: "35vh", overflowY: "auto" }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                        <ListBox className='survey-listbox' options={configOpts} optionLabel='column_header' multiple filter itemTemplate={listBoxOptionTemplate} value={displayColumns?.selected} onChange={(e) => { setDisplayColumns((prev) => ({ ...prev, selected: e.target?.value })); isChange.current = true; }} />
                    </div>
                )
            },
        ];


    }

    return useMemo(() => ({
        loader, columns, rowData, tooltip, handleExcelDownload, overlayRef, saveColumnConfiguration, getMenuItems, isChange, displayColumns, setDisplayColumns
    }), [loader, columns, rowData, tooltip, handleExcelDownload, overlayRef, saveColumnConfiguration, getMenuItems, isChange, displayColumns, setDisplayColumns])
}